import { useMutation } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import axios from '../apis/axios';
import { TOKEN_NAME } from "../config";
const cookies = new Cookies();

function useDownloadFile() {

    const reportDownload = useMutation((data) => downloadReports(data), {
        onSuccess: (data) => {
            const href = URL.createObjectURL(new Blob([data.data]));
            let a = document.createElement('a');
            a.href = href;
            a.download = 'ProductsQr.pdf';
            a.click();
        },
        onError: () => {
        }
    })

    const downloadReports = async (data) => {
        let TOKEN = cookies.get(TOKEN_NAME);
        let fd = new FormData()
        for (var key in data) {
            fd.append(key, data[key]);
        }
        let res = await axios(
            {
                method: "post",
                url: `/generateQrcodePdf`,
                responseType: 'blob',
                data: fd,
                headers: { Authorization: TOKEN ? `Bearer ${TOKEN}` : '' }
            })
        return res
    };


    return { reportDownload }
}

export default useDownloadFile